import { ShieldAlert } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';
import { TableSkeleton } from '../../../shared/components/TableSkeleton';
import { ExpectedReturnsTable } from '../components/ExpectedReturnsTable';
import { useExpectedReturns } from '../hooks/use-expected-returns';

/** The yard's landing screen: the trucks on their way back, each opening its receive screen. */
export function ExpectedReturnsPage() {
  const { state, list, isRefreshing } = useExpectedReturns();

  // The route's errorElement shows the failure, so the page does not invent a second kind of error screen.
  if (state.status === 'error') throw state.error;

  return (
    <>
      <h1 className="mb-1 text-xl font-semibold tracking-tight text-fg">Trucks due back</h1>
      <p className="mb-4 text-sm text-muted">Open a truck to check its readings and paperwork, then receive it.</p>
      {state.status === 'forbidden' && (
        <EmptyState
          icon={ShieldAlert}
          title="You can't receive trucks"
          description="Receiving trucks at the yard needs the yard supervisor's permission. Ask an administrator."
        />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading trucks due back" withSearch rows={6} />}
      {state.status === 'loaded' && <ExpectedReturnsTable page={state.page} list={list} isRefreshing={isRefreshing} />}
    </>
  );
}
